<template>
  <li class="toast">
    <article class="ui message single" :class="toast.type">
      <i class="close icon" @click="remove(toast._id)"></i>

      <header class="header" v-if="toast.header">
        {{ toast.header }}
      </header>

      <p v-if="toast.text">{{ toast.text }}</p>
    </article>
  </li>
</template>

<style lang="scss" scoped>
.toast {
  .ui.message.single {
    margin: 0.5em;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
      0 3px 1px -2px rgba(0, 0, 0, 0.12);
  }
}
</style>

<script>
// @flow
export default {
  name: 'toast',
  props: {
    toast: Object,
    remove: Function
  }
}
</script>
